import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import HeaderReport from "../../../../components/Pdf/Header";
import { styles } from "../../../../components/Pdf/pdfGeneral/EstiloPdf";

const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
});

/**
 * Estilo que se repite en todas los headers de la tabla
 */
const styleHeadForAll = {
  borderStyle: "solid", 
  borderWidth: 1,
  backgroundColor: "#646464",
  color: 'white',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 9
}

const styleCellForAll = {
  borderStyle: "solid", 
  borderWidth: 1, 
  borderTopWidth: 0 ,
}

/**
 * Estilos del pdf
 */
const s = StyleSheet.create({
  body: {
    padding: 15,
  },
  subTitle:{ //SUBTITULOS
    width:"100%",
    textAlign: 'left',
    marginBottom: 10,
    marginLeft: 10,
    fontSize: 9
  },
  tableColHeaderCC: { //HEADER CLAVE CONCEPTO
    width: "20%",
    height: 20, 
    ...styleHeadForAll
  }, 
  tableColHeaderCon: { //HEADER CONCEPTO
    width: "40%",  
    borderLeftWidth: 0,
    ...styleHeadForAll
  }, 
  tableColHeaderOC: { //HEADER OCURRENCIAS
    width: "20%", 
    borderLeftWidth: 0,
    ...styleHeadForAll
  }, 
  tableColHeaderIm: { //HEADER Importe
    width: "20%", 
    borderLeftWidth: 0,
    ...styleHeadForAll
  },
  tableColContentReport: { //CONTENIDO
    width: "100%"
  },
  tableColContentCC: { //Cell CC
    width: "20%", 
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    ...styleCellForAll
  }, 
  tableColContentCon: { //Cell Concepto
    width: "40%", 
    borderLeftWidth: 0,
    ...styleCellForAll
  },
  tableColContentOC: { //Cell Ocurrencias
    width: "20%", 
    borderLeftWidth: 0, 
    ...styleCellForAll
  },
  tableColContentIm: { //Cell importe
    width: "20%", 
    borderLeftWidth: 0, 
    ...styleCellForAll
  },
  tableColContentEmpty: { //Cell vacio
    width: "60%", 
    borderLeftWidth: 0, 
    ...styleCellForAll
  },
  tableColRowEmpty: { //Row vacio
    width: "100%", 
    height: 20,
    borderLeftWidth: 0, 
    ...styleCellForAll
  },
  cellColumn: { 
    width: "100%", 
    fontSize: 8 ,
    flexDirection: "row" ,
    justifyContent: 'center',
    alignItems: 'center',
  },
  displayContent: { 
    paddingLeft: 9, //centra el content
    marginVertical: 4,
    flexDirection: "row",
    justifyContent: 'space-around',
  }
})


export default function generatePDFcifras(data, model, title, fileNo) {
  const ori = model.orientation === "h" ? "landscape" : "portrait";

  const firstTable = data.filter(data => data.keyTypeUnder === "1");
  const secondTable = data.filter(data => data.keyTypeUnder === "2");
  

  function getContentTable(table) {
    if (table.length > 0) {
      const total = table.reduce((ac, value) => {
        const NImp = value.importe.replace("$", "").replace(/,/g, "");
        return ac + Number(NImp);
      }, 0);
      const content = table.map(value => (
        <View style={styles.tableRow} wrap={false}>
          <View style={s.tableColContentCC}>
            <Text style={s.cellColumn}>
              {value[model.content[0].value]}
            </Text>
          </View>
          <View style={s.tableColContentCon}>
            <Text style={s.cellColumn}>
              {value[model.content[1].value]}
            </Text>
          </View>
          <View style={s.tableColContentOC}>
            <Text style={s.cellColumn}>
              {value[model.content[2].value]}
            </Text>
          </View>
          <View style={s.tableColContentIm}>
            <Text style={s.cellColumn}>
              {value[model.content[3].value]}
            </Text>
          </View>
        </View>
      ))
      return (
        <>
        {content}
        <View style={styles.tableRow} wrap={false}>
          <View style={s.tableColContentEmpty}>
            <Text style={s.cellColumn}>
            </Text>
          </View>
          <View style={s.tableColContentOC}>
            <Text style={s.cellColumn}>
              TOTAL
            </Text>
          </View>
          <View style={s.tableColContentIm}>
            <Text style={s.cellColumn}>
              {formatter.format(total)}
            </Text>
          </View>
        </View>
        </>
      )
    }
    return null
  }
  
  return {
    report: (
      <>
        <Document>
          
          <Page style={s.body} orientation={ori}>
            <HeaderReport/>
            <View>
              <Text style={s.subTitle}>{title}</Text>
              <Text style={s.subTitle}>{`Periodo: ${model.descr.period} Año: ${model.descr.year}`}</Text>
              {model.descr.stateFund !== undefined ? (
                <Text style={s.subTitle}>{model.descr.stateFund}</Text>
              ) : null}
            </View>
            <View style={styles.table}>
              {/* Cabeceras */}
              <View style={styles.tableRow} fixed>
                <View style={s.tableColHeaderCC} fixed>
                  <Text>{model.headers[0]}</Text>
                </View>
                <View style={s.tableColHeaderCon} fixed>
                  <Text>{model.headers[1]}</Text>
                </View>
                <View style={s.tableColHeaderOC} fixed>
                  <Text>{model.headers[2]}</Text>
                </View>
                <View style={s.tableColHeaderIm} fixed>
                  <Text>{model.headers[3]}</Text>
                </View>
              </View>
              <View style={s.tableColContentReport}>
                {getContentTable(firstTable)}
                <View style={styles.tableRow} wrap={false}>
                <View style={s.tableColRowEmpty}>
                  <Text style={s.cellColumn}>
                  </Text>
                </View>
                </View>
                {getContentTable(secondTable)}
              </View>
            </View>

            <View fixed style={styles.spaceFooter}></View>
            <View fixed style={styles.footer}>
              <Text style={styles.textFooter}>{fileNo}</Text>
              <Text
                style={styles.textFooter}
                render={({ pageNumber, totalPages }) =>
                  `PAGINA : ${pageNumber} / ${totalPages}`
                }
              />
            </View>
          </Page>
        </Document>
      </>
    ),
  };
}
